import { Injectable } from '@angular/core';
import { NotificationTopicSchemaPartnerSubMaintenanceController } from './NotificationTopicSchemaPartnerSubMaintenanceController';

@Injectable()
export class NotificationTopicSchemaPartnerInspectorSubMaintenanceController extends NotificationTopicSchemaPartnerSubMaintenanceController {

    public getResourceRoot(): string {
        return "NOTIFICATIONTOPICSCHEMAPARTNER.INSPECTOR";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/partner/inspector/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}